export default ({ dropdown }) => ({
  root: {
    position: 'relative',
    zIndex: 1
  },
  dark: {},
  inputWrapper: {
    margin: [0, 10, 4, 10],
    background: 'transparent',
    position: 'relative',
    '&$dark input::placeholder': {
      color: dropdown.dark.placeholderColor
    },
    '& input': {
      background: 'transparent',
      boxSizing: 'border-box',
      paddingRight: 40,
      borderRadius: 3,
      height: 32,
      '&::placeholder': {
        fontWeight: 400,
        color: dropdown.placeholderColor
      }
    }
  },
  autocomplete: {
    '&$dark': {
      color: dropdown.dark.text
    },
    color: dropdown.text,
    fontSize: 14,
    fontWeight: 400,
    left: 21,
    position: 'absolute',
    zIndex: -1,
    top: 9,
    userSelect: 'none'
  },
  spacer: {
    visibility: 'hidden',
    userSelect: 'none',
    zIndex: -1,
    position: 'relative'
  },
  suggestion: {
    '&$dark': {
      background: dropdown.dark.highlightBg
    },
    background: dropdown.highlightBg,
    userSelect: 'none'
  }
});
